"use client";

import React from "react";
import { ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function CallToAction() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.2
  });
  return <section data-section-id="170734" id="calltoaction-banner" className="bg-background text-foreground relative w-full pt-16 md:pt-24">
      <div className="relative bg-primary text-primary-foreground">
        {}
        <div className="absolute top-0 inset-x-0 -translate-y-[99%] text-primary overflow-hidden leading-none pointer-events-none">
          <svg viewBox="0 0 1440 100" fill="currentColor" preserveAspectRatio="none" className="w-full h-12 md:h-24" aria-hidden="true">
            <polygon points="0,100 720,0 1440,100" />
          </svg>
        </div>

        <div className="container mx-auto px-6 py-20 md:py-32 relative z-10">
          <div ref={ref} className={`max-w-4xl mx-auto text-center flex flex-col items-center transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
            <h2 className="font-serif text-4xl md:text-5xl lg:text-7xl font-bold text-accent mb-6 leading-tight tracking-tighter">
              Begin Your Path to Better Health
            </h2>
            
            <p className="text-lg md:text-xl lg:text-2xl text-primary-foreground/90 mb-12 max-w-2xl font-sans tracking-normal leading-relaxed">
              Expert care available at our state-of-the-art clinics in Limassol and Nicosia. Schedule your consultation with our specialists today.
            </p>
            
            <Link to="/ContactPage">
              <Button variant="secondary" size="lg" className="h-14 px-10 text-base md:text-lg uppercase tracking-widest font-semibold group rounded-full shadow-lg hover:shadow-xl transition-all duration-300">
                Book Your Appointment
                <ArrowRight className="ml-3 w-5 h-5 transition-transform duration-300 group-hover:translate-x-2" />
              </Button>
            </Link>
          </div>
        </div>
      </div>
    </section>;
}